/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unused-state */
// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';

import { EventSelect2 } from 'wdna-select2';
import { WidgetGrid, JarvisWidget } from 'wdna-components/lib';
import { initProcess, finishProcess } from 'wdna-components/lib/scheduler/actions';
import { removeTab } from 'wdna-components/lib/tabs';
import Loader from 'wdna-components/lib/loaders/local/Loader';
import UiValidate from 'wdna-components/lib/forms/validation/UiValidate';
import { messageError, messageInfo, messageBoxWarning } from 'wdna-components/lib/helpers/notification';
import { getErrorMessage } from 'wdna-components/lib/helpers/response';

import { config } from '../../../../../config/config';
import { client, ClientDO, company, CompanyDO } from '../../../requests';
import { typeClient, TypeClientDO } from '../../../../configuration/requests';

import { routes } from '../../../../dashboard';

import Form from './Form';

interface Props {
  rowId: number;
  notify?: () => void;
}

interface State {
  loading?: boolean;
  data: Partial<ClientDO>;
  companiesArray?: Partial<CompanyDO>[];
  typeClientArray?: TypeClientDO[];
  accessListArray?: any[];
  code?: string;
  isFile?: boolean;
  modalShow?: boolean;
  modalData?: any;
  id?: number;
  update?: string;
}

export default class Edit extends React.Component <Props, State> {
  private pid: string;
  private fileId: any;
  private fileName: any;
  private defaultValues: any;

  public constructor(props: Props) {
    super(props);

    this.pid = window.getStr();
    this.fileId = window.getStr();
    this.fileName = window.getStr();
    this.defaultValues = {};

    this.state = {
      loading: false,

      companiesArray: [],
      typeClientArray: [],
      accessListArray: [],

      code: '',
      isFile: false,
      modalShow: false,
      modalData: {},

      id: 0,

      data: {
        active: false,
        validated: false,
      },
    };
  }

  public componentDidMount(): void {
    this.load().catch(() => { /* pass */ });
  }

  public load = async (): Promise<void> => {
    const { rowId } = this.props || {};
    const isNew: any = !!isNaN(rowId);

    this.loadingStart();
    try {
      const [companiesArray, typeClientArray] = await Promise.all([
        company<Partial<CompanyDO>[]>('list') || new Array<Partial<CompanyDO>>(0),
        typeClient<TypeClientDO[]>('list') || [],
      ]);

      // Add empty value to companies
      companiesArray.unshift({ id: 0, name: '(empty)' });

      let clientRow: Partial<ClientDO> = this.state.data;
      if (!isNew) {
        clientRow = await client<ClientDO>('get', String(rowId)) || {};
      }

      const accessListArray: any[] = routes.map((r: any) => ({ id: r.code, name: r.name }));
      this.setState(
        {
          data: { ...clientRow },
          companiesArray,
          typeClientArray,
          accessListArray,
        },
        () => {
          this.defaultValues = _.cloneDeep(clientRow);
        }
      );
    } catch (error) {
      messageError('Error', getErrorMessage(error));
    }
    this.loadingFinish();
  };

  public loadingStart = (): void => {
    this.setState({
      loading: true,
    });
    window.store.dispatch(initProcess(this.pid));
  };

  public loadingFinish = (): void => {
    this.setState({
      loading: false,
    });
    window.store.dispatch(finishProcess(this.pid));
  };

  public handleUploadFile = (): void => {
    const { id, data } = this.state;

    const { fileId } = this;
    const file: any = $(`#${fileId}`).prop('files');
    if (!file[0]) {
      if (isNaN(Number(id))) {
        messageError('Error', 'Please select a valid file');
        return;
      }
    }

    const formData: FormData = new FormData();
    formData.append('ufile', file[0]);

    if (data?.id !== undefined && !isNaN(data.id)) {
      formData.append('id', String(data.id));
    }

    const options: any = { headers: { 'Content-Type': 'multipart/form-data' } };

    this.loadingStart();
    client('dashboard', undefined, formData, options)
      ?.then(() => {
        messageInfo('Success', `Dashboard successfully ${data?.id ? 'edited' : 'created'}`, 5000);
        const { notify } = this.props || {};
        if (typeof notify === 'function') {
          notify();
        }
        window.store.dispatch(removeTab('CE'));
      })
      .catch((error: any) => {
        this.uploadingError(error);
      })
      .finally(() => {
        this.loadingFinish();
      });
  };

  public handleDeletedFile = (): void => {
    const { data } = this.state;

    messageBoxWarning('Delete', 'Do you want to delete this register ?', () => {
      const formData: FormData = new FormData();
      formData.append('id', String(data?.id));

      const options: any = { headers: { 'Content-Type': 'multipart/form-data' } };

      this.loadingStart();
      client('dashboard', undefined, formData, options)
        ?.then(() => {
          messageInfo('Success', 'Dashboard successfully deleted', 5000);
          const { notify } = this.props || {};
          if (typeof notify === 'function') {
            notify();
          }
          window.store.dispatch(removeTab('CE'));
        })
        .catch((error: any) => {
          this.uploadingError(error);
        })
        .finally(() => {
          this.loadingFinish();
        });
    });
  }

  public uploadingError = (error: any): void => {
    if (error) {
      messageError('Error', getErrorMessage(error));
    } else {
      messageError('Error', 'Unknown error');
    }
  };

  public onReset = (): void => {
    this.setState({
      data: {
        ...this.defaultValues,
      },
    });
  };

  public onInfo = (value: any): void => {
    this.setState({
      update: window.getStr(),
      modalShow: true,
      modalData: value,
    });
    const { rowId } = this.props || {};
    const { protocol } = location;
    const host: string = protocol.concat('//', window.location.hostname);
    const url: string = host.concat(`/dashboard/client_${rowId}.json`);

    this.chkFileOnURL(url).catch(() => { /* pass */ });
  };

  public onCloseModal = (): void => {
    this.setState({
      update: window.getStr(),
      modalShow: false,
    });
  };

  public submit = (event: React.FormEvent<HTMLFormElement>): any => {
    event.preventDefault();
    const { data } = this.state;
    if (!this.isValidForm(data)) return;

    this.loadingStart();
    client('set', undefined, data)
      ?.then(() => {
        messageInfo('Success', `Customer successfully ${data?.id ? 'edited' : 'created'} ${data?.name}`, 5000);
        const { notify } = this.props || {};
        if (typeof notify === 'function') {
          notify();
        }
        window.store.dispatch(removeTab('CuE'));
      })
      .catch((error: any) => {
        messageError('Error', getErrorMessage(error));
      })
      .finally(() => {
        this.loadingFinish();
      });
  };

  public isValidForm = (data: Partial<ClientDO>): boolean => {
    const { email, accessList } = data;
    if (!data.typeClient) {
      messageError('Error', 'Please select a client type');
      return false;
    }

    if (accessList?.[0] === undefined) {
      messageError('Error', 'Please enter a valid dashboard');
      return false;
    }

    const expression: RegExp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/i;
    const isValidEmail: any = expression.test(email || '');
    if (!isValidEmail) {
      messageError('Error', 'Please enter a valid email');
      return false;
    }

    return true;
  };

  public handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>): void => {
    const { tagName, name, type, checked } = (e as React.ChangeEvent<HTMLInputElement>).target;
    const value: any = type === 'checkbox' ? checked : e.target.value;
    if (tagName === 'SELECT') {
      const [outerName, innerName] = name.split('.');
      this.setState((prevState: State) => ({
        data: {
          ...prevState.data,
          [outerName]: {
            [innerName]: value,
          },
        },
      }));
    } else {
      this.setState((prevState: State) => ({
        data: {
          ...prevState.data,
          [name]: value,
        },
      }));
    }
  };

  public changeFileName = (): void => {
    const { fileId, fileName } = this;
    const file: any[] = $(`#${fileId}`).prop('files');
    if (!file[0]) {
      return;
    }

    const { name } = file[0];
    $(`#${fileName}`).val(name);
  };

  public handleChangeTwo = (e: React.ChangeEvent<HTMLInputElement>): void => {
    this.changeFileName();
    const { name, value, tagName } = e.target;

    if (tagName === 'SELECT') {
      const [outerName, innerName] = name.split('.');
      this.setState((prevState: State) => ({
        ...prevState,
        [outerName]: {
          [innerName]: value,
        },
      }));
    } else {
      this.setState((prevState: State) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  public handleChangeMultiple = (e: EventSelect2): void => {
    const { id, selected } = e.params.data;
    if (selected) {
      this.addValue(id);
    } else {
      this.remValue(id);
    }
  };

  public addValue = (id: string): any => {
    this.setState((prevState: State) => {
      const { data } = prevState;
      const newList: string[] = _.cloneDeep(data?.accessList) || [];
      if (newList.includes(id)) return prevState;
      return { data: { ...data, accessList: [...newList, id] } };
    });
  };

  public remValue = (id: string): any => {
    this.setState((prevState: State) => {
      const { data } = prevState;
      const newList: string[] = _.cloneDeep(data?.accessList) || [];
      return { data: { ...data, accessList: newList.filter((item: any) => item !== id) } };
    });
  };

  public chkFileOnURL = async (url: string): Promise<boolean> => {
    const result: boolean = await fetch(url, { method: 'HEAD', mode: 'cors' })
      .then((resp: Response) => { return resp.ok; }, () => { return false; })
      .catch(() => { return false; });
    this.setState({
      isFile: result,
    });
    return result;
  }

  public download = (): void => {
    const { rowId } = this.props || {};
    const { isFile } = this.state;
    const { protocol } = location;
    const host: string = protocol.concat('//', window.location.hostname);
    if (isFile) {
      const url: string = host.concat(`/dashboard/client_${rowId}.json`);
      fetch(url).then((response: Response) => {
        response.blob().then((blob: Blob) => {
          const href: string = window.URL.createObjectURL(blob);
          const a: HTMLAnchorElement = document.createElement('a');
          a.href = href;
          a.download = `client_${rowId}.json`;
          a.click();
        }).catch((error: any) => {
          messageError('Error', getErrorMessage(error));
        });
      }).catch((error: any) => {
        messageError('Error', getErrorMessage(error));
      });
    }
  }

  public genApiKey = (): void => {
    const time: number = new Date().getTime();

    const apikey: string = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c: string) => {
      // eslint-disable-next-line no-bitwise
      const r: number = (time + Math.random() * 16) % 16 | 0;
      // TODO: remove ?
      // const d: number = Math.floor(time / 16);
      // eslint-disable-next-line no-bitwise, no-mixed-operators
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    this.setState((prevState: State) => ({
      data: {
        ...prevState.data,
        apikey,
      },
    }));
  }

  public showFreeboard = (): void => {
    const { rowId } = this.props || {};
    const source: string = `${config.fbdRootUrl}#source=/dashboard/client_${rowId}.json`;
    window.open(source, `freeboard_client_${rowId}`, 'width=750,height=550,scrollbars=YES');
  }

  public render(): JSX.Element {
    const { data, loading } = this.state;
    const { fileId, fileName } = this;

    return (
      <div id="content">
        <WidgetGrid>
          <div className="row">
            <article className="col-sm-12 col-md-12 col-lg-12">
              <JarvisWidget
                editbutton={false}
                togglebutton={false}
                colorbutton={false}
                deletebutton={false}
                custombutton={false}
                fullscreenbutton={false}
              >
                <div className="widget-body">
                  <Loader show={loading} overlay={false} />
                  <UiValidate>
                    <form className="smart-form" onSubmit={this.submit} method="post" encType="multipart/form-data">
                      <header>
                        <h2>
                          <span className="widget-icon" style={{ padding: '8px' }}>
                            <i className="fa fa-edit" />
                          </span>
                          Customer {data?.id ? `Edit: ${data.id}` : 'New'}
                        </h2>
                      </header>
                      <Form
                        formValues={this.state}
                        onChange={this.handleChange}
                        onChangeTwo={this.handleChangeTwo}
                        onChangeMultiple={this.handleChangeMultiple}
                        onCloseModal={this.onCloseModal}
                        onHandleUploadFile={this.handleUploadFile}
                        onHandleDeletedFile={this.handleDeletedFile}
                        onInfo={this.onInfo}
                        fileId={fileId}
                        fileName={fileName}
                        onReset={this.onReset}
                        download={this.download}
                        genApiKey={this.genApiKey}
                        showFreeboard={this.showFreeboard}
                      />
                    </form>
                  </UiValidate>
                </div>
              </JarvisWidget>
            </article>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}
